function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.9992 13.3024L11.7492 7.67324C11.4183 7.09906 11.3289 6.41702 11.5007 5.77699C11.6725 5.13696 12.0914 4.59132 12.6653 4.25998C13.2392 3.92864 13.9211 3.83872 14.5613 4.00996C15.2015 4.18121 15.7475 4.59962 16.0793 5.17324L21.0793 13.8335",
  stroke: "#FBFBFB",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.169 16.6684L6.41904 8.44119C6.25456 8.15685 6.14773 7.84289 6.10465 7.51725C6.06157 7.1916 6.08309 6.86066 6.16797 6.54334C6.25286 6.22602 6.39944 5.92853 6.59936 5.66789C6.79927 5.40725 7.04858 5.18855 7.33306 5.02431C7.61753 4.86007 7.93158 4.7535 8.25726 4.7107C8.58294 4.66789 8.91386 4.68968 9.23111 4.77483C9.54837 4.85998 9.84573 5.00682 10.1062 5.20695C10.3667 5.40708 10.5852 5.65658 10.7492 5.94119L14.9992 13.3024",
  stroke: "#FBFBFB",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M19.2492 20.6636C18.5861 19.5152 18.4064 18.1504 18.7497 16.8695C19.0929 15.5886 19.9309 14.4965 21.0793 13.8335L19.8293 11.6684C19.6648 11.3841 19.558 11.0701 19.5149 10.7445C19.4718 10.4188 19.4933 10.0879 19.5782 9.77058C19.6631 9.45326 19.8097 9.15577 20.0096 8.89513C20.2095 8.63449 20.4588 8.4158 20.7433 8.25155C21.0278 8.08731 21.3418 7.98075 21.6675 7.93794C21.9932 7.89513 22.3241 7.91693 22.6414 8.00207C22.9586 8.08722 23.256 8.23406 23.5165 8.43419C23.7769 8.63432 23.9954 8.88382 24.1594 9.16843L26.6594 13.4986C27.3164 14.6359 27.7429 15.8914 27.9145 17.1936C28.0862 18.4957 27.9996 19.8189 27.6598 21.0876C27.32 22.3563 26.7336 23.5456 25.9342 24.5877C25.1347 25.6297 24.1377 26.504 23.0003 27.1607C21.8628 27.8174 20.6072 28.2436 19.305 28.415C18.0028 28.5864 16.6796 28.4995 15.411 28.1595C14.1424 27.8194 12.9532 27.2327 11.9113 26.433C10.8695 25.6333 9.99536 24.6361 9.33891 23.4986L4.58891 15.2713C4.25805 14.6971 4.16869 14.0151 4.34047 13.3751C4.51225 12.735 4.93112 12.1894 5.50501 11.8581C6.07891 11.5267 6.76088 11.4368 7.40105 11.608C8.04122 11.7793 8.58721 12.1977 8.91903 12.7713L11.169 16.6684",
  stroke: "#FBFBFB",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M22 2.87375C23.3167 2.87357 24.6102 3.22018 25.7504 3.8787C26.8907 4.53722 27.8373 5.48442 28.4952 6.625",
  stroke: "#FBFBFB",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M8.3669 30C7.02273 28.8731 5.88708 27.5188 5.01179 25.9987",
  stroke: "#FBFBFB",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgCheer = function SvgCheer(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCheer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cheer.458bde3f.svg";
export { ForwardRef as ReactComponent };